import { useCallback, useEffect, useRef, useState } from "react";

export function useToast(duration = 2200) {
  const [message, setMessage] = useState("");
  const timer = useRef<number | null>(null);

  const show = useCallback(
    (text: string) => {
      setMessage(text);
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setMessage(""), duration);
    },
    [duration]
  );

  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    []
  );

  return { message, show };
}